import { useContext } from 'react';

import { FwPageContext } from './FwPageContext';

const useFwPage = () => useContext(FwPageContext) || [];

export { useFwPage };
